module.exports = __webpack_public_path__ + "img/ACADEMY.cc9f01da.svg";